import API from 'services/api';

interface IProps {
  reservationId: string;
  type: string;
  paymentId?: string;
}

export const saveCalculationDocument = ({
  reservationId,
  type,
  paymentId = '',
}: IProps): Promise<any> => {
  return API.post(
    `/api/accommodation/calculations/${reservationId}/documents/${type}/${paymentId}`,
    {
      responseType: 'blob',
    },
  ).then(response => response?.data);
};
